import { Input, Label } from "reactstrap";
import Dropzone from "react-dropzone-uploader";
import { API_BASE_URL } from "../../api/api";
import Swal from "sweetalert2";

export const DataImgForm = ({
  imageFiles,
  handleImageChange,
  removeImageSlot,
  addImageSlot,
  mainImage,
  onSelectMainImage,
  imagesFromServer = [],
}) => {
  const getUploadParams = () => ({ url: "https://httpbin.org/post" });

  const handleChangeStatus = (fileWithMeta, status, index) => {
    const { file } = fileWithMeta;

    if (status === "done") {
      const isUpdating = !!imageFiles[index];
      handleImageChange(file, index, isUpdating);
    }

    if (status === "removed") {
      confirmRemoveImage(index);
    }
  };

  const confirmRemoveImage = (index) => {
    Swal.fire({
      title: "¿Eliminar imagen?",
      text: "Despues de guardar esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        removeImageSlot(index);
        Swal.fire("Eliminada", "La imagen ha sido eliminada.", "success");
      }
    });
  };

  const allImages = imageFiles.length > 0 ? imageFiles : imagesFromServer;

  return (
    <div className="ui-card">
      <h3 style={{ margin: "0 0 6px", fontSize: 16, fontWeight: 700 }}>Imágenes</h3>
      <p style={{ margin: "0 0 16px", color: "#8A91AE", fontSize: 11.5 }}>
        La primera imagen es la portada en la tienda.
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {allImages.map((file, index) => {
          const isServerImage = typeof file === "string";
          const previewUrl = isServerImage
            ? `${API_BASE_URL}/product/get/file/${file}`
            : file
            ? URL.createObjectURL(file)
            : null;
          const isMain = mainImage == index;

          return (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                padding: 10,
                border: `1.5px solid ${isMain ? "#4B36F0" : "#E8EAF2"}`,
                borderRadius: 11,
                background: isMain ? "#F3F1FE" : "#FAFAFF",
              }}
            >
              <div className="ui-upload-slot" style={{ width: 64, height: 64, flexShrink: 0 }}>
                {isMain && <span className="ui-upload-slot__cover">Portada</span>}
                {previewUrl ? (
                  <img src={previewUrl} alt={`Imagen ${index + 1}`} />
                ) : (
                  <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "#9AA1BC", fontSize: 10 }}>
                    Sin imagen
                  </div>
                )}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <Dropzone
                  getUploadParams={getUploadParams}
                  onChangeStatus={(meta, status) => handleChangeStatus(meta, status, index)}
                  maxFiles={1}
                  multiple={false}
                  canCancel={false}
                  inputContent={file ? "Cambiar imagen" : "Arrastra o selecciona imagen"}
                  styles={{
                    dropzone: {
                      minHeight: 46,
                      padding: 6,
                      border: "1.5px dashed #C3C8DC",
                      borderRadius: 9,
                      background: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    },
                    inputLabel: { fontSize: 12.5, color: "#5A6187", fontWeight: 500 },
                  }}
                />
              </div>

              <Label style={{ display: "flex", alignItems: "center", gap: 7, margin: 0, fontSize: 12.5, fontWeight: 600, cursor: previewUrl ? "pointer" : "not-allowed", color: previewUrl ? "#3B4266" : "#C3C8DC" }}>
                <Input
                  type="radio"
                  name="mainImage"
                  style={{ width: 16, height: 16, margin: 0 }}
                  checked={isMain}
                  onChange={() => onSelectMainImage(index)}
                  disabled={!previewUrl}
                />
                Principal
              </Label>

              <button
                type="button"
                onClick={() => confirmRemoveImage(index)}
                style={{ width: 30, height: 28, flexShrink: 0, border: "1px solid #F6C9C9", borderRadius: 7, background: "#fff", color: "#DC2626", cursor: "pointer" }}
              >
                <i className="ri-delete-bin-line" style={{ fontSize: 13 }} />
              </button>
            </div>
          );
        })}
      </div>

      <button
        type="button"
        onClick={addImageSlot}
        style={{ marginTop: 14, display: "flex", alignItems: "center", gap: 7, border: "1px solid #E1E4F0", background: "#fff", color: "#3B4266", borderRadius: 9, padding: "9px 14px", fontFamily: "inherit", fontSize: 12.5, fontWeight: 600, cursor: "pointer" }}
      >
        <i className="ri-add-line" /> Agregar imagen
      </button>
    </div>
  );
};
